import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  InputSignal,
  Signal,
} from '@angular/core';
import { ComponentStatus } from '@lyceo/shared/util-models';

@Component({
  selector: 'homi-avatar',
  templateUrl: 'avatar.component.html',
  styleUrls: ['avatar.component.scss'],
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': '"status-"+status()',
  },
})
export class AvatarComponent {
  public readonly name: InputSignal<string> = input.required<string>();

  public readonly picture: InputSignal<string | undefined> = input<string>();

  public readonly status: InputSignal<ComponentStatus> = input<ComponentStatus>(
    ComponentStatus.PRIMARY,
  );

  protected readonly initials: Signal<string> = computed(() => {
    const names: string[] = this.name().trim().split(/\s+/);
    if (names.length === 0 || names[0] === '') {
      return '';
    }
    const firstInitial: string = names[0][0];
    const lastInitial: string =
      names.length > 1 ? names[names.length - 1][0] : '';
    return (firstInitial + lastInitial).toUpperCase();
  });
}
